<template>
  <div>
    <div class="dataTable" style="margin-top:0;">
      <div class="table-title">{{$t('DriverAnalysis.dailyWorkHour')}}</div>
      <div class="rightAll-btn">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('DriverAnalysis.driverNum')">
            <el-input
              size="mini"
              v-model="formInline.driverNum"
              :placeholder="$t('DriverAnalysis.form.driverNum')"
              style="width: 150px"
              class="input-with-select"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('DriverAnalysis.name')">
            <el-input
              size="mini"
              v-model="formInline.name"
              :placeholder="$t('DriverAnalysis.form.name')"
              style="width: 150px"
              class="input-with-select"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              size="mini"
              type="primary"
              @click="onSearch"
              class="btn-chaxun"
              >{{$t('common.btn.search')}}</el-button
            >
            <el-button size="mini" @click="onClear" class="btn-del"
              >{{$t('common.btn.cancel')}}</el-button
            >
          </el-form-item>
        </el-form>
        <el-button v-if="isPrimaryKey('DRIVERANALYSIS_DRIVERORGREPORT_MONTH_DOWN')" type="text" @click="downCar">{{$t('common.btn.download')}}</el-button>
      </div>
      <i-table
        :list="list"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="option"
        :columns="columns"
        :operates="operates"
      ></i-table>
      <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
  </div>
</template>

<script>
import MonthTime from "./MonthTime";
export default MonthTime;
</script>

<style lang="less" scoped>
@import "../../../../../assets/styles/Style.less";
</style>
